<template>
  <div class="ws-data-multiple-layer-list">
    <p class="ws-data-multiple-layer-list__title">章節列表</p>
    <div class="ws-data-multiple-layer-list__content">
      <WsDataMultipleLayerListItem
        v-for="(item,itemIndex) in listItems"
        :key="itemIndex"
        :value="item"
        :isEditing="editingItems.length > 0"
        @edit="$_addEditingItem($event)"
        @edit-end="$_removeEditingItem($event)"
      ></WsDataMultipleLayerListItem>
    </div>
    <WsBtn
      @click="$_createClick()"
      color="primary"
      outlined
      class="ws-data-multiple-layer-list__btn"
    >
      <v-icon left>mdi-plus</v-icon> 新增章
    </WsBtn>
  </div>
</template>
<script>
export default {
  name: "WsDataMultipleLayerList",
  data: () => ({
    editingItems: [],
    listItems: [
      {
        id: 1,
      },
      {
        id: 2,
      },
    ],
  }),
  methods: {
    $_addEditingItem($event) {
      this.editingItems.push($event);
    },
    $_removeEditingItem($event) {
      const itemIndex = this.editingItems.indexOf($event);
      this.editingItems.splice(itemIndex, 1);
    },
    $_createClick() {
      console.log("create-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-data-multiple-layer-list";
</style>